import { TILE_SIZES, TILESIZES_TO_INCHES } from '@mixtiles/web-backend-shared'
import {
  getCollageLayouts,
  getCollageLayoutsPerStyle,
} from '../../api/collageLayout.api'
import axios from 'axios'
import { getPortfolioVariant } from './collagesPortfolio'

const UPLOADED_SQUARE_SIZE = TILE_SIZES.SQUARE_20X20
export const UPLOADED_PORTRAIT_SIZE = TILE_SIZES.RECTANGLE_20X27
export const UPLOADED_LANDSCAPE_SIZE = TILE_SIZES.RECTANGLE_27X20

// Map to different layouts per photosCount + tileSize
const _layoutsCache = {}

// Map of a specific svg file text from photosCount + tileSize + style
const _svgCache = {}

const getLayoutsCacheKey = (photosCount, tileSize) => {
  return `layout-${photosCount}-${tileSize}`
}

const getSVGCacheKey = (layout) => {
  return `svg-${layout._id}`
}

export const mapTileSizeToUploadedSize = (tileSize) => {
  const SPECIFIC_COLLAGE_SIZES = [
    TILE_SIZES.RECTANGLE_22X44,
    TILE_SIZES.RECTANGLE_44X22,
  ]
  if (SPECIFIC_COLLAGE_SIZES.includes(tileSize)) {
    return tileSize
  }

  const { width, height } = TILESIZES_TO_INCHES[tileSize]

  if (width === height) {
    return UPLOADED_SQUARE_SIZE
  } else if (width > height) {
    return UPLOADED_LANDSCAPE_SIZE
  } else {
    return UPLOADED_PORTRAIT_SIZE
  }
}

export const fetchLayoutSVGText = async (layout) => {
  const svgCacheKey = getSVGCacheKey(layout)
  if (_svgCache[svgCacheKey]) {
    return _svgCache[svgCacheKey]
  }

  const svgContent = await axios.get(layout.svgPath)
  let textSvgContent
  if (layout.textSvgPath) {
    textSvgContent = await axios.get(layout.textSvgPath)
  }

  _svgCache[svgCacheKey] = {
    svgContent: svgContent.data,
    textSvgContent: textSvgContent ? textSvgContent.data : null,
  }

  return _svgCache[svgCacheKey]
}

export const fetchCollageLayouts = async (photosCount, { tileSize }) => {
  const uploadedSize = mapTileSizeToUploadedSize(tileSize)

  const cacheKey = getLayoutsCacheKey(photosCount, uploadedSize)

  if (_layoutsCache[cacheKey]) {
    return _layoutsCache[cacheKey]
  }

  const portfolioVariant = getPortfolioVariant()
  const layouts = portfolioVariant.allowMissingPhotos
    ? await getCollageLayoutsPerStyle(
        portfolioVariant.styles,
        photosCount,
        uploadedSize,
        portfolioVariant.id
      )
    : await getCollageLayouts(photosCount, uploadedSize, portfolioVariant.id)

  const sortedLayouts = layouts.sort(
    (layout1, layout2) =>
      portfolioVariant.styles.indexOf(layout1.style) -
      portfolioVariant.styles.indexOf(layout2.style)
  )

  const layoutsMap = {}
  for (const layout of sortedLayouts) {
    await fetchLayoutSVGText(layout)
    layoutsMap[layout.style] = layout
  }

  _layoutsCache[cacheKey] = layoutsMap
  return layoutsMap
}

export const shouldUpdateCollageLayout = (tile, newTileSize) =>
  tile.collage &&
  tile.collage.layout.tileSize !== mapTileSizeToUploadedSize(newTileSize)
